export class BackedUpStorageDateHistogram {
    'data';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<VisualizationHistogramSeries>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackedUpStorageDateHistogram.attributeTypeMap;
    }
    constructor() {
    }
}
